import CarRentalContainerMobile from '../../../../components/containers/CarRentalContainerMobile';
import preloadCustomProps from '../../../utils/preloads/preloadCarRentalProps';
import deepmerge from '../../../utils/deepmerge';

const cmpConfig = {
  name: 'car-rental-container--mobile',
  moduleId: 'em-cmp-lib-airmodules',
  staticAssetsHost: 'https://em-frontend-assets.airtrfx.com',
  version: 'NO_NEEDED',
  containerConfig: {
    settings: {
      instance: CarRentalContainerMobile
    }
  },
  hooks: {
    params: {},
    preloadCustomProps
  }
};

const finalConfig = deepmerge(cmpConfig, {});

export default finalConfig;
